import { render, staticRenderFns } from "./exchange-success.vue?vue&type=template&id=0548148e&"
import script from "./exchange-success.vue?vue&type=script&lang=js&"
export * from "./exchange-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports